import { render, staticRenderFns } from "./details-wares.vue?vue&type=template&id=5c42819c&scoped=true"
import script from "./details-wares.vue?vue&type=script&lang=js"
export * from "./details-wares.vue?vue&type=script&lang=js"
import style0 from "./details-wares.vue?vue&type=style&index=0&id=5c42819c&prod&lang=scss&scoped=true"
import style1 from "./details-wares.vue?vue&type=style&index=1&id=5c42819c&prod&scoped=true&lang=css"
import style2 from "./details-wares.vue?vue&type=style&index=2&id=5c42819c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c42819c",
  null
  
)

export default component.exports